<!--!&#45;&#45; Hero Start &ndash;&gt;-->
<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/sri-lanka.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">All your holiday arrangements to
                        suite your budget.</h1>
                    <p class="para-desc text-white-50">We arrange inbound journeys to Sri Lanka from a vast number of
                        international locations. We always thrive to cater to the travel preferences of each client and
                        have excellent relationships with repeat clients.</p>
                    <!--                    <div class="mt-4">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-icon btn-pills btn-lg btn-light">-->
                    <!--                            <i-feather name="arrow-down" class="icons"></i-feather>-->
                    <!--                        </a>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!-- Hero End -->

<section class="section">
    <div class="container">
        <div class="row">
            <button (click)="custom()" class="btn btn-soft-success ml-3 mb-3">
                <i class="uil uil-plus"></i>
                Create Your own
            </button>
            <button (click)="pacbyCategory(p.id)" *ngFor="let p of category" class="btn btn-soft-secondary ml-3 mb-3">
                {{p.category}}</button>
        </div>
        <div *ngIf="package==null" class="row justify-content-center mt-5">
            <mat-spinner></mat-spinner>
        </div>
        <!--        <div class="row" *ngIf="package!=null">-->
        <!--            <div class="col-5 mb-4 row mr-3" style="padding: 0">-->
        <!--                <div class="btn-group   " style="width: 100%" ngbDropdown>-->
        <!--                    <button style="width: 100%" type="button" class="btn bg-soft-primary dropdown-toggle"-->
        <!--                            data-toggle="dropdown" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">-->
        <!--                        Categories-->
        <!--                    </button>-->
        <!--                    <div class="dropdown-menu border-danger" ngbDropdownMenu style="width: 100%">-->
        <!--                        <a class="dropdown-item text-center text-primary" *ngFor="let pac of category"-->
        <!--                           (click)="pacbyCategory(pac.id)"><b>{{pac.category}}</b></a>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                &lt;!&ndash;                <select class="form-control mr-4" >&ndash;&gt;-->
        <!--                &lt;!&ndash;                    <option *ngFor="let pac of category" (click)="pacbyCategory(pac.id)" value="{{pac.id}}">{{pac.category}}</option>&ndash;&gt;-->
        <!--                &lt;!&ndash;                </select>&ndash;&gt;-->
        <!--            </div>-->
        <!--            <div class="col-3 mb-4 row " style="padding: 0">-->
        <!--                <button class="btn btn-primary btn-sm ml-3" (click)="custom()">Create your own</button>-->
        <!--            </div>-->

        <!--        </div>-->
        <!--        <div class="row text-center mb-4">-->
        <!--            <button   class="btn btn-soft-warning mr-2 " (click)="all()"> All </button>-->
        <!--            <button *ngFor="let pac of category"  class="btn btn-soft-warning mr-2" (click)="search(pac)"> {{pac.category}} </button>-->
        <!--        </div>-->
        <div *ngFor="let pac of package" class="row mb-5">
            <!--            <h4 style="position: absolute" class="mb-3">{{pac.category}}</h4>-->
            <div class="mt-4 row col-12">
                <div class="col-xl-4 col-lg-4 mb-3" *ngFor="let p of pac.travelPackageList" [hidden]="p.status==9">
                    <div class="card img shadow-md"
                         style=" height:15rem; background-size: cover; background: url({{p.url}});border-radius: 10px">
                        <div class="bg-overlay" style="border-radius: 10px"></div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <h4 style="color: white">{{p.packageName}}</h4>
                                    <!--                                    <p class="text-muted">He lay on his armour-like back, and if he lifted his head.</p>-->
                                </div>
                                <div class="col-12" style=" bottom: 10px;position: absolute;">
                                    <button class="btn btn-primary" style=" margin-top: 31px;" (click)="booking(p)">
                                        book now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>


<!-- Modal Content Start -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Package details</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="bg-white p-3 rounded box-shadow">
            <h4>{{details.packageName}}</h4>
            <p class="text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque culpa debitis
                dolorum est ex id iure labore modi nesciunt numquam odio omnis pariatur qui saepe vitae, voluptate,
                voluptatem voluptatibus voluptatum!</p>
            <p class="text-primary">{{details.packageStartDate}}  to  {{details.packageEndDate}}</p>
            <p>{{details.noOfDays}} Days</p>
            <h6>itenary</h6>
            <p class="text-secondary" *ngFor="let d of details.itenary">{{d.description}}</p>
            <br>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Close</button>
    </div>
</ng-template>
<!-- Modal Content End -->

<!--end col-->
<!-- Modal End -->
